module.exports = __webpack_public_path__ + "img/Leitung.b42a1e31.svg";